import { render, staticRenderFns } from "./CoozzyDetailCard.vue?vue&type=template&id=bf0ef270&scoped=true"
import script from "./CoozzyDetailCard.vue?vue&type=script&lang=js"
export * from "./CoozzyDetailCard.vue?vue&type=script&lang=js"
import style0 from "./CoozzyDetailCard.vue?vue&type=style&index=0&id=bf0ef270&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0ef270",
  null
  
)

export default component.exports